import clsx from "clsx";
import { FC } from "react";

import { modelRoleModelNames } from "@tsmono/inspect-common/utils";

import { EvalSpecModelRoles } from "../../../@types/extraInspect";

import styles from "./ModelRolesView.module.css";

interface ModelRolesViewProps {
  roles: EvalSpecModelRoles | null;
}

/**
 * Renders the Navbar
 */
export const ModelRolesView: FC<ModelRolesViewProps> = ({ roles }) => {
  const modelRoles = roles || {};

  // Render as a single line if there is only a single
  // model role
  const singleLine = Object.keys(modelRoles).length !== 1;

  // Render a layout of model roles
  const modelEls = Object.keys(modelRoles).map((key) => {
    const role = key;
    const roleData = modelRoles[role];
    const model = roleData ? modelRoleModelNames(roleData) : undefined;
    return (
      <div
        className={clsx(
          singleLine ? styles.grid : undefined,
          "text-style-secondary",
          "text-size-smallest"
        )}
        key={key}
      >
        <span className={clsx("text-style-label")}>{role}:</span>
        <span>{model}</span>
      </div>
    );
  });
  return modelEls.length > 0 ? (
    <div className={styles.container}>{modelEls}</div>
  ) : undefined;
};
